module.exports = __webpack_public_path__ + "img/step10.c78fd511.png";